import React from 'react';
import { Configure, InstantSearch, Hits } from 'react-instantsearch';
import { searchClient } from '../../lib/searchClient';
import SingleEstate from '../../components/SingleEstate';
import { Link } from 'react-router-dom';

const NewestEstates = ({ regionId }) => {
    // Construct the filter query correctly
    const filterQuery = regionId ? `parent_region_id:${regionId}` : '';

    return (
        <InstantSearch
            indexName="estates"
            searchClient={searchClient}
        >
            <Configure
                hitsPerPage={12}
                filters={filterQuery}
            />

            <div className="mt-6">
                <Hits
                    hitComponent={({ hit }) => (
                        <Link to={`/estate/${hit.id}`} key={`estate-${hit.id}`}>
                            <SingleEstate estate={hit} />
                        </Link>
                    )}
                    classNames={{
                        list: 'grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-10 lg:grid-cols-3 lg:gap-x-8',
                    }}
                />
            </div>
        </InstantSearch>
    );
};

export default NewestEstates;